// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"134":"7fe24810","326":"3fbc11e6","554":"1195a3fc","609":"9564f496","615":"638bbc92"}[chunkId] + ".js";
};